import React from "react";
import PropTypes from "prop-types";
import { Grid } from "@material-ui/core";
import { makeStyles, useTheme } from "@material-ui/core/styles";

import { GeofencesLayerTypes } from "../../constants";

const useStyles = makeStyles((theme) => ({
  typeCircle: {
    flexShrink: 0,
    width: theme.spacing(1.5),
    height: theme.spacing(1.5),
    marginRight: theme.spacing(1),
    borderRadius: "50%",
    border: `2px solid ${theme.palette.text.lightgrey}`,
  },
}));

const LayerWithType = (props) => {
  const theme = useTheme();
  const classes = useStyles(theme);

  return (
    <Grid container alignItems="center" wrap="nowrap">
      <div
        className={classes.typeCircle}
        style={{
          background: theme.palette.geofencesTypeColors[props.type]
            ? `${theme.palette.geofencesTypeColors[props.type]}75`
            : "transparent",
          borderColor: theme.palette.geofencesTypeColors[props.type] ||
            theme.palette.text.lightgrey,
        }}
      />
      {props.children}
    </Grid>
  );
};

LayerWithType.propTypes = {
  type: PropTypes.oneOf(Object.values(GeofencesLayerTypes)),
  children: PropTypes.node,
};

LayerWithType.defaultProps = {
  type: GeofencesLayerTypes.none,
  children: null,
};

export default LayerWithType;
